import React, { useState } from "react";
import { Tooltip } from "@logora/debate.dialog.tooltip";
import { InfoIcon } from "@logora/parliament.icons.regular_icons";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from "./Box.module.scss";

export const Box = ({
    title,
    titleStyle = "default",
    headerIcon,
    children,
    className,
    helperText,
    visibleCount = 1,
    childBorder = true,
}) => {
    const titleStyleClasses = Array.isArray(titleStyle)
        ? titleStyle.map((l) => styles[l]).join(" ")
        : styles[titleStyle];
    const [currentIndex, setCurrentIndex] = useState(0);
    const childrenArray = React.Children.toArray(children);
    
    const nextChild = () => {
        setCurrentIndex((prevIndex) => {
            const nextIndex = prevIndex + visibleCount;
            return nextIndex >= childrenArray.length ? 0 : nextIndex;
        });
    };

    const prevChild = () => {
        setCurrentIndex((prevIndex) => {
            const prevIndexAdjusted = prevIndex - visibleCount;
            return prevIndexAdjusted < 0 ? childrenArray.length - visibleCount : prevIndexAdjusted;
        });
    };

    const childrenToDisplay = childrenArray.slice(currentIndex, currentIndex + visibleCount);

    return (
        <div className={`${className} ${styles.boxContainer}`}>
            <div className={styles.boxHeader}>
                {headerIcon && <span className={styles.headerIcon}>{headerIcon}</span>}
                <span className={`${styles.title} ${titleStyleClasses}`}>{title}</span>
                {helperText && (
                    <div className={styles.tooltip}>
                        <Tooltip text={helperText}>
                            <InfoIcon width={18} height={18} />
                        </Tooltip>
                    </div>
                )}
                {childrenArray.length > visibleCount && (
                    <>
                        <div className={styles.navigationContainer}>
                            <button className={styles.navigationButton} type="button" onClick={prevChild}>
                                <ChevronLeftIcon />
                            </button>
                            <button className={styles.navigationButton} type="button" onClick={nextChild}>
                                <ChevronRightIcon />
                            </button>
                        </div>
                        <div className={styles.slideDots}>
                            {Array.from({ length: Math.ceil(childrenArray.length / visibleCount) }).map((_, index) => (
                                <span
                                    key={index}
                                    className={`${styles.dot} ${index === Math.floor(currentIndex / visibleCount) ? styles.activeDot : ''}`}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
            <div className={styles.contentContainer} style={{ display: 'flex' }}>
                {childrenToDisplay.map((child, index) => (
                    <div
                        key={index}
                        style={{
                            flex: 1,
                            alignSelf: 'stretch',
                            width: `${100 / visibleCount}%`,
                            borderRight: ((index < childrenToDisplay.length - 1 ) && childBorder) ? '1px solid #E9E9E9' : 'none',
                            paddingRight: index < childrenToDisplay.length - 1 ? '1em' : 'none'
                        }}
                    >
                        { child }
                    </div>
                ))}
            </div>
        </div>
    );
};